import styled from "styled-components/native";
import { light_black, palladium, spacing_l, spacing_s } from "../../StyleHelpers";
import TouchableButton from "../../components/TouchableButton";
import LabelContainer from "../../components/SettingsComponent/labelContainer";
import { StyleSheet } from "react-native";

//#region Index
export const StyledButtonSettings = styled.View`
	width: 344px;
	padding-top: 20px;
	padding-bottom: 20px;
`;

export const StyledButtonContainer = styled.View`
	justify-content: center;
	align-items: center;
	margin-bottom: 20px;
`;

export const StyledContainerSettings = styled.View`
	margin-left: ${spacing_l};
`;
//#endregion

//#region Account
export const StyledAccount = styled.View`
	gap: 1rem;
	padding-top: 30px;
	padding-bottom: 20px;
`;

export const StyledContainerAccount = styled.View`
	padding: 0px 0px ${spacing_s} 0px;
`;

export const StyledTransaction = styled.View`
	gap: ${spacing_s};
	flex-direction: row;
`;

export const StyledNoTransaction = styled.View`
	gap: 16px;
`;

export const StyledTransactionHistory = styled.View`
	gap: 16px;
`;

//#endregion

//#region AddScreen
export const StyledAddScreenContainer = styled.View`
	padding-top: 30px;
	padding-bottom: 40px;
	gap: 1rem;
`;

export const StyledTitle = styled.Text`
	margin-bottom: 16px;
`;

export const StyledTextContainer = styled.View<any>`
	width: ${(props) => (props.isNarrow ? "20vw" : "30vw")};
	margin-bottom: 40px;
`;

export const StyledText = styled.Text`
	color: ${palladium};
`;

export const StyledContainerAddScreen = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;

export const StyledNarrowAddScreen = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`;
export const StyledNarrowContainerAddScreen = styled.View`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	width: 49.3%;
	gap: 1rem;
`;

//#endregion

//#region Data Management
export const StyledContainer = styled.View`
	flex: 1;
	background-color: ${light_black};
`;
//#endregio
//#endregion

//#region Help and About
export const StyledContainerHelpAndAbout = styled.View`
	padding: 0px 0px ${spacing_l} 0px;
	width: 100%;
`;
//#endregion

//#region Advance
export const StyledAdvance = styled.View`
	gap: 2rem;
	margin-bottom: 2rem;
`;

export const StyledContainerAdvance = styled.View`
	flex-direction: row;
	justify-content: space-between;
`;

export const StyledCenteredContainer = styled.View`
	flex-direction: row;
	justify-content: center;
`;
export const PaddedContainer = styled.View`
	flex-direction: row;
	justify-content: start;
`;

export const Label = styled(LabelContainer)`
	padding-bottom: 0px;
`;

export const StyledButton = styled(TouchableButton)`
	max-width: 23%;
`;

export const StyledPartialSettingsContainer = styled.View`
	padding-bottom: 30px;
`;

export const StyledMarginTop = styled.View`
	margin-top: 30px;
`;

export const stylesAdvance = StyleSheet.create({
	centeredContainer: {
		backgroundColor: "#111111",
	},
	container: {
		backgroundColor: "#111111",
	},
	dropdownContainer: {
		paddingHorizontal: 30,
		paddingBottom: 20,
	},
	dropdown: {
		height: "72px",
		width: "75%",
		borderColor: "#2362be",
		borderWidth: 2,
		fontSize: 18,
		borderRadius: 16,
		paddingHorizontal: 24,
		marginLeft: spacing_l,
		backgroundColor: "black",
	},
	icon: {
		marginRight: 5,
	},
	placeholderStyle: {
		fontSize: 16,
		color: "white",
	},
	selectedTextStyle: {
		fontSize: 24,
		color: "white",
	},
	inputSearchStyle: {
		padding: 10,
		height: 40,
		fontSize: 18,
		borderRadius: 8,
		color: "black",
		borderWidth: 0,
	},
});

//#endregion
